export const formikErrorMessages = {
  required: "Bitte ausfüllen",
  notMatching: "Passwörter stimmen nicht überein",
  eMail: "Bitte eine gültige E-Mailadresse eingeben",
};
